import React from 'react'
import { Box, Flex, Heading, Image, Text } from '@theme-ui/components';
import styled from '@emotion/styled';

const ContentCardWrapper = styled(Flex)`
  height: 250px;
  padding: 10px;
  margin: 10px;
  border: 1px solid #DDD;
  box-shadow: 0px 3px 10px #DEDEDE;
  border-radius: 4px;
  overflow: hidden;
  flex-direction: column;
  justify-content: space-between;
`

const TagText = styled(Box)`
  text-transform: uppercase;
  font-size: 0.7rem;
  color: ${props => props.theme.colors.muted2};
  padding: 5px 0;
  max-width: 100px;
`

const ContentCard = ({ title, children, tagsLeft, tagsRight }) => {
  return (
    <ContentCardWrapper
      sx={{
        width: ['100%', '50%', '30%']
      }}>
      <Flex sx={{ flexDirection: 'column' }}>
        <Heading sx={{ color: 'primary' }} mt={1} mb={2} variant="wikiHeading4">{title}</Heading>
        {children}
      </Flex>
      <Flex sx={{ alignItems: 'flex-end', flexDirection: 'row', justifyContent: 'space-between' }}>
        <div>
          {tagsLeft.map(tag => <TagText>{tag}</TagText>)}
        </div>
        <div>
          {tagsRight.map(tag => <TagText sx={{ textAlign: 'right'}}>{tag}</TagText>)}
        </div>
      </Flex>
    </ContentCardWrapper>
  );
}

export default ContentCard;